import { render, staticRenderFns } from "./createEmailAccount.vue?vue&type=template&id=4fe837ed&scoped=true&"
import script from "./createEmailAccount.vue?vue&type=script&lang=js&"
export * from "./createEmailAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe837ed",
  null
  
)

export default component.exports